import { PropsWithChildren } from 'react';
import { useGATrackPageView } from './ga.hooks';

export const TrackPageView = ({ children }: PropsWithChildren): JSX.Element => {
    useGATrackPageView();

    return <>{children}</>;
};
